import { UserRole } from "tm-shared/types";

import packageJson from "../../package.json";

export const ENVIRONMENT: "prod" | "dev" | "dev-local" = import.meta.env
    .VITE_ENVIRONMENT;
export const CONFIG_MANIFEST_URL: string = import.meta.env.VITE_MANIFEST;

const title =
    ENVIRONMENT === "prod"
        ? "Trade Master"
        : `${ENVIRONMENT.toUpperCase()} Trade Master`;

export const APP_VERSION = packageJson.version;
export const APP_VERSION_PERSIST = packageJson["persist-version"];
export const APP_VERSION_CONFIG = 384;

export const KPI_DELAY_DAYS = Number(import.meta.env.VITE_KPI_DELAY_DAYS || 0);

export const DISABLE_PWA_TRIGGER = ENVIRONMENT !== "prod";

export const MERCURE_HUB_URL =
    "https://mercure.trademaster.in.ua/.well-known/mercure";

export const CONFIG_MERCURE_TOPIC = "system";

const loader = {
    delay: 300,
    minimumLoading: 700,
};

const defaultMetaTags = {
    image: "/pwa-512x512.png",
    description: "React app",
};

export { defaultMetaTags, loader, title };

export const reminderDelayTimeType = "hour";
export const reminderDelayValue = 1;

export const ALLOW_APP_ROLES: UserRole[] = [
    UserRole.Ta,
    UserRole.Md,
    UserRole.Sv,
    UserRole.Svm,
    UserRole.Kam,
    UserRole.Hos,
];
